export default __webpack_public_path__ + "public/images/errors/not-found@2x.png?ac03e848";